import styled, { css } from 'styled-components';

import Button from '@src/components/ui/Button';
import { IconWrapper } from '@src/components/ui/Button/Button.styles';
import { MenuItem } from '@src/components/ui/Menu';

type DropdownItemProps = {
  selected?: boolean;
  dataDropdownItem?: boolean;
  disabled?: boolean;
};

type DropdownWrapperProps = {
  fullWidth?: boolean;
};

type DropdownButtonProps = {
  open?: boolean;
  fullWidth?: boolean;
  error?: boolean;
};

export const DropdownWrapper = styled.div<DropdownWrapperProps>`
  display: inline-block;
  width: ${({ fullWidth }) => fullWidth && '100%'};
`;

export const DropdownItem = styled(MenuItem)<DropdownItemProps>`
  font-weight: ${({ selected, theme }) =>
    selected ? theme.fontWeight.bold : theme.fontWeight.light};
  margin: ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  background-color: ${({ theme, disabled }) =>
    disabled && theme.colors.neutral[100]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary[50]};
  }
`;

export const DropdownButton = styled(Button)<DropdownButtonProps>`
  width: ${({ theme, fullWidth }) => (fullWidth ? '100%' : theme.spacing[52])};
  position: relative;
  height: auto;
  min-height: ${({ theme }) => theme.spacing[11]};
  text-align: left;
  padding: 0 ${({ theme }) => theme.spacing[4]};

  ${({ error, theme }) =>
    error &&
    css`
      box-shadow: inset 0 0 0 1px ${theme.colors.danger[500]};
    `}

  ${IconWrapper} {
    height: ${({ theme }) => theme.spacing[6]};
    width: ${({ theme }) => theme.spacing[6]};
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  }

  ${DropdownItem} {
    height: auto;
    padding: 0;
    font-weight: ${({ theme }) => theme.fontWeight.medium};

    &:after {
      content: none;
    }
  }

  .button-body {
    justify-content: flex-start;
  }

  .button-label {
    flex-grow: 1;
  }
`;
